// extracted by mini-css-extract-plugin
export var viewerContainer = "OSDViewer-module--viewerContainer--Sz6H8";
export var controlsContainer = "OSDViewer-module--controlsContainer--xT1-t";
export var zoomButton = "OSDViewer-module--zoomButton--36CcV";
export var muralFilter = "OSDViewer-module--muralFilter--1zEcg";
export var loadingSpinner = "OSDViewer-module--loadingSpinner--xRIaI";
export var spinning = "OSDViewer-module--spinning--3k2uz";